import React, { useState } from "react";
import { Box, Button, TextField, CircularProgress } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";

import AuthLayout, { authField, AuthLabel } from "../../components/auth/AuthLayout";
import { showAppAlert } from "../../../store/reducers/appreducer";
import { paths } from "../../../routes/paths";
import { baseURL } from "../../../config";
import tokens from "../../theme/tokens";

const { color, font } = tokens;

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPwd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!EMAIL.test(email)) {
      setError("Enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${baseURL}forgotPassword/`, { email });
      dispatch(
        showAppAlert({
          show: true,
          alertType: "success",
          alertMessage: "Email to reset your password has been sent.",
        })
      );
      navigate(paths.v1.signin);
    } catch (err) {
      dispatch(
        showAppAlert({
          show: true,
          alertType: "error",
          alertMessage: err.response?.data?.message || "Something went wrong.",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset password"
      subtitle="We'll email you a link to set a new password."
      footer={
        <>
          Remembered it?{" "}
          <Box
            component={Link}
            to={paths.v1.signin}
            sx={{
              font: `700 12.5px ${font.sans}`,
              color: color.indigo,
              textDecoration: "none",
            }}
          >
            Sign in
          </Box>
        </>
      }
    >
      <form onSubmit={handleSubmit} noValidate>
        <AuthLabel>Work email</AuthLabel>
        <TextField
          fullWidth
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          error={Boolean(error)}
          helperText={error}
          sx={{ ...authField, mb: 2.25 }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={loading}
          sx={{ py: 1.5, fontSize: 13.5 }}
        >
          {loading ? (
            <CircularProgress size={18} sx={{ color: "#fff" }} />
          ) : (
            "Send reset link →"
          )}
        </Button>
      </form>
    </AuthLayout>
  );
};

export default ForgotPwd;
